import React, { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import useOrchestrationById from '../../../utils/hooks/use_orchestration_by_id';
import useTaskList from '../../../utils/hooks/use_task_list';

const OrchestrationDataContext = React.createContext({
  error: null,
  loading: false,
  orchestration: null,
  taskData: [],
});

export const OrchestrationDataProvider = ({ children }) => {
  const routeParams = useParams();

  const { loading, error, orchestration } = useOrchestrationById(routeParams?.id);
  const sha = orchestration?.sha;

  // TODO - Move to separate context for task list (better performance)
  const { taskData, loading: tasksLoading, error: tasksError } = useTaskList({ orchSha: sha });

  const dataContextValue = useMemo(() => ({
    orchestration,
    taskData,
    loading,
    error,
    tasksLoading,
    tasksError,
  }), [
    orchestration,
    taskData,
    loading,
    error,
    tasksLoading,
    tasksError,
  ])

  return (
    <OrchestrationDataContext.Provider
      value={dataContextValue}
    >
      { children }
    </OrchestrationDataContext.Provider>
  )
};

export const useOrchestrationData = () => useContext(OrchestrationDataContext)

export default useOrchestrationData;
